import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DmsChangeFormComponent } from './dms-change-form/dms-change-form.component';
import { LandingPageRequestComponent } from './landing-page-request/landing-page-request.component';
import { TechRequestComponent } from './tech-request/tech-request.component';
import { AppService } from '../../store/app.service';
import { CreativeRequestComponent } from './creative-request/creative-request.component';
import { InstanceService } from '../../core/instance/instance.service';
import { SendEmailModal } from '../../shared/modals/send-email/send-email.component';
import { NOTES_TYPE } from '../../core/helpers/constants';

@Component({
  selector: 'app-forms',
  templateUrl: './forms.component.html',
  styleUrls: ['./forms.component.scss']
})
export class FormsComponent implements OnInit {

  constructor(
    private modalService: NgbModal,
    private appService: AppService,
    public instance: InstanceService) {
  }

  ngOnInit(): void {
    this.appService.setPageTitle$('FORMS');
  }

  openChangeDmsModal() {
    this.modalService.open(DmsChangeFormComponent, { 
      size: 'md',
      backdrop: 'static',
    });
  }
  openLpRequestModal() {
    this.modalService.open(LandingPageRequestComponent, { 
      size: 'lg',
      backdrop: 'static',
    });
  }
  openCreativeRequestModal() {
    this.modalService.open(CreativeRequestComponent, { 
      size: 'lg',
      backdrop: 'static',
    });
  }
  openTechRequestModal(campaignId?: string) {
    const modalRef = this.modalService.open(TechRequestComponent, { 
      size: 'lg',
      backdrop: 'static',
    });
    if (campaignId) {
      modalRef.componentInstance.campaignId = campaignId;
    }
  }
  openSendEmailModal(): void {
    const modalRef = this.modalService.open(SendEmailModal, {
      size: 'xl',
      backdrop: 'static',
    });
    void modalRef.result.then((result: any) => {}, (): void => undefined);
  }

}
